import Box from '@redbubble/design-system/src/Box';
import React from 'react';
import styles from './Star.module.scss';

interface StarProps {
  rotation: number;
  size: number;
  x: number;
  y: number;
}

export const Star: React.FC<StarProps> = ({
  rotation = 0,
  size = 20,
  x = 0,
  y = 0,
}) => {
  return (
    <Box>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 23 22"
        fill="none"
        style={{
          transform: `rotate(${rotation}deg) translate(${x}px, ${y}px)`,
        }}
        className={styles.twinkling}
        data-testid="star-svg"
      >
        <path
          d="M0.888835 10.3728C7.26789 8.77361 9.17113 6.8608 10.7711 0.484777C10.8073 0.345956 10.8885 0.223043 11.0021 0.135312C11.1156 0.0475817 11.2551 -9.32695e-07 11.3986 -9.45241e-07C11.5421 -9.57788e-07 11.6816 0.0475817 11.7951 0.135312C11.9087 0.223042 11.9899 0.345956 12.026 0.484776C13.626 6.8608 15.5397 8.77361 21.9188 10.3728C22.0577 10.409 22.1807 10.4902 22.2684 10.6037C22.3562 10.7171 22.4038 10.8565 22.4038 11C22.4038 11.1434 22.3562 11.2828 22.2684 11.3963C22.1807 11.5098 22.0577 11.591 21.9188 11.6272C15.5397 13.2264 13.626 15.1392 12.026 21.5152C11.9899 21.654 11.9087 21.7769 11.7951 21.8647C11.6816 21.9524 11.5421 22 11.3986 22C11.2551 22 11.1156 21.9524 11.0021 21.8647C10.8885 21.7769 10.8073 21.654 10.7711 21.5152C9.17114 15.1392 7.26789 13.2264 0.888835 11.6272C0.749948 11.591 0.62696 11.5098 0.539189 11.3963C0.451417 11.2828 0.40381 11.1434 0.40381 11C0.40381 10.8565 0.451417 10.7172 0.539189 10.6037C0.62696 10.4902 0.749947 10.409 0.888835 10.3728Z"
          fill="#CDC3FF"
        />
      </svg>
    </Box>
  );
};
